import React from 'react';

const Spacer = props => {
  return (
    <div className='dui-block dui-pb-8' {...props}></div>
  );
};

export default Spacer;